import  { createContext, useState, ReactNode, FC, useMemo } from "react";
import { AmountDetails, PayModel } from "../../type";


// Define the context type
export interface PaymentContextType {
  list: PayModel[];
  edit: any;
  setEdit: (edit: any ) => void;
  setList: (list: any) => void;
  success: boolean;
  setsuccess: (success: boolean) => void;
  show: boolean;
  setShow: (show: boolean) => void;
  amountDetails: AmountDetails;
  setAmountDetails: (amountDetails: any) => void;
  balance:number;
  setBalance:(balance:number)=>void;
}

// Create the context
export const PaymentContext = createContext<PaymentContextType | null>(null);


interface PaymentContextProps {
  children: ReactNode;
}

export const PaymentListProvider: FC<PaymentContextProps> = ({ children }) => {
  const [list, setList] = useState<any[]>([]);
  const [edit, setEdit] = useState<any>(null);
  const [success, setsuccess] = useState(false);
  const [show, setShow] = useState(true);
  const [amountDetails, setAmountDetails] = useState<any>(null);
  const [balance, setBalance] = useState<number>(0)

  const contextValue = useMemo(() => ({
    list,
    setList,
    edit,
    setEdit,
    success,
    setsuccess,
    show,
    setShow,
    amountDetails,
    setAmountDetails,
    balance,
    setBalance
  }), [list, edit, success, show, amountDetails,balance]);

  return (
    <PaymentContext.Provider value={contextValue}>
      {children}
    </PaymentContext.Provider>
  );
};
